<aside id="sidebar" class="sidebar">
  <ul class="sidebar-nav" id="sidebar-nav">
    <li class="nav-item" style="border-bottom: 1px solid white !important;">
      <a
        class="nav-link"
        routerLink="/dashboard"
        [routerLinkActive]="['active']"
        ><img
          src="assets/img/onbording.png"
          alt=""
          style="width: 12%; height: 24px"
        />&nbsp;&nbsp;<span> {{ lang.Dashboard }}</span>
      </a>
    </li>

    <li class="nav-item" *ngIf="role == 'ADMINISTRATOR' && environment.production==false" style="border-bottom: 1px solid white !important;">
      <a
        class="nav-link"
        data-bs-target="#forms-nav2"
        data-bs-toggle="collapse"
        href="#"
        (click)="toggleChevron5()"
        routerLink="/product-catalog"
        [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: false }"
        ><img
          src="assets/img/open-book.png"
          alt=""
          class="icon-color"
          style="width: 12%; height: 24px"
        />&nbsp;&nbsp;<span>{{ lang.Product_Catalog }}</span>
        <i
          *ngIf="role == 'ADMINISTRATOR'"
          [ngClass]="{
            'bi-chevron-right': showChevronSettings,
            'bi-chevron-down': !showChevronSettings
          }"
          class="ms-auto"
        ></i>
      </a>
      <ul
        *ngIf="role == 'ADMINISTRATOR'"
        id="forms-nav2"
        class="nav-content collapse ulheigh"
      >
        <li class="nav-item">
          <a
            class="nav-link"
            routerLink="/tax-tables"
            [routerLinkActive]="['active']"
            ><img
              src="assets/img/income.png"
              alt=""
              class="icon-color"
              style="width: 12%; height: 24px; color: white"
            />&nbsp;&nbsp;<span> {{ lang.Tax_Table }}</span>
          </a>
        </li>

        <li class="nav-item">
          <a
            class="nav-link"
            routerLink="/supplier"
            [routerLinkActive]="['active']"
            ><img
              src="assets/img/supplier.png"
              alt=""
              class="icon-color"
              style="width: 12%; height: 24px; color: white"
            />&nbsp;&nbsp;<span> {{ lang.Supplier }}</span>
          </a>
        </li>
      </ul>
    </li>

    <li class="nav-item" *ngIf="role == 'ADMINISTRATOR'" style="border-bottom: 1px solid white !important;">
      <a
        [class.disabled]="!isLinkActive"
        (click)="isLinkActive ? null : $event.preventDefault()"
        class="nav-link"
        routerLink="/manageUsers"
        [routerLinkActive]="['active']"
        ><img
          src="../../../assets/img/manageusers.png"
          alt=""
          style="width: 12%; height: 24px"
        />&nbsp;&nbsp;<span> {{ lang.System_Users }}</span>
      </a>
    </li>

    <!-- <li class="nav-item" *ngIf="role=='ADMINISTRATOR'"> <a class="nav-link" routerLink="/myplans"
            [routerLinkActive]="['active']"><img src="../../../assets/img/manageplanicon.png" alt=""
               style="width:12%;height:24px">&nbsp;&nbsp;<span>{{lang.Plans}}</span> </a></li> -->
    <li class="nav-item" *ngIf="role == 'ADMINISTRATOR'" style="border-bottom: 1px solid white !important;">
      <a class="nav-link" routerLink="/plans" [routerLinkActive]="['active']"
        ><img
          src="../../../assets/img/manageplanicon.png"
          alt=""
          style="width: 12%; height: 24px"
        />&nbsp;&nbsp;<span>{{ lang.Plans }}</span>
      </a>
    </li>
    <!-- <li class="nav-item" *ngIf="role=='ADMINISTRATOR'"> <a class="nav-link" routerLink="/plans"
            [routerLinkActive]="['active']"><img src="../../../assets/img/manageplanicon.png" alt=""
               style="width:12%;height:24px">&nbsp;&nbsp;<span>{{lang.Plans}}</span> </a></li> -->

    <!-- [class.disabled]="!isLinkActive"
            (click)="isLinkActive ? null : $event.preventDefault()" -->
    <li class="nav-item" *ngIf="role == 'ADMINISTRATOR'">
      <a
        class="nav-link"
        data-bs-target="#forms-nav2"
        data-bs-toggle="collapse"
        href="#"
        (click)="toggleChevron5()"
        routerLink="/manageAdvisors"
        [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: false }"
        ><img
          src="../../../assets/img/manageadvisors.png"
          alt=""
          style="width: 12%; height: 24px"
        />&nbsp;&nbsp;<span>{{ lang.Advisors }}</span>
        <i
          *ngIf="role == 'ADMINISTRATOR'"
          [ngClass]="{
            'bi-chevron-right': showChevronSettings,
            'bi-chevron-down': !showChevronSettings
          }"
          class="ms-auto"
        ></i>
      </a>
      <ul
        *ngIf="role == 'ADMINISTRATOR'"
        id="forms-nav2"
        class="nav-content collapse ulheigh"
      >
        <!-- <li class="nav-item" *ngIf="role == 'ADMINISTRATOR'" >
          <a
            class="nav-link"
            [class.disabled]="!isLinkActive"
            (click)="isLinkActive ? null : $event.preventDefault()"
            routerLink="/payable"
            [routerLinkActive]="['active']"
            ><img
              src="../../../assets/img/payablesicon.png"
              alt=""
              style="width: 12%; height: 24px"
            />&nbsp;&nbsp;<span>{{ lang.Payables }}</span>
          </a>
        </li> -->
      <li class="nav-item">
      <a
        class="nav-link"
        routerLink="/payable"
        [routerLinkActive]="['active']"
      >
        <img
         src="../../../assets/img/payablesicon.png"
          alt=""
          style="width: 12%; height: 24px"
        />
        &nbsp;&nbsp;<span>{{ lang.Payables }}</span>
      </a>
    </li>
     
      </ul>
    </li>

    <li class="nav-item" *ngIf="role != 'ADMINISTRATOR'" style="border-bottom: 1px solid white !important;">
      <a
        class="nav-link"
        routerLink="/manageAdvisors"
        [routerLinkActive]="['active']"
        ><img
          src="../../../assets/img/manageadvisors.png"
          alt=""
          style="width: 12%; height: 24px"
        />&nbsp;&nbsp;<span>{{ lang.Advisors }}</span>
      </a>
    </li>

    <!-- <li class="nav-item" *ngIf="false"> <a class="nav-link " routerLink="/manageCorporates/addCorporate" [routerLinkActive]="['active']"><img src="../../../assets/img/managecorporate.png" alt="" style="width:12%;height:24px">&nbsp;&nbsp;<span>Corporate Customers</span> </a></li> -->

    <!-- <li class="nav-item ">
      <a
        class="nav-link"
        routerLink="/manageCorporates"
        [routerLinkActive]="['active']"
        ><img
          src="../../../assets/img/managecorporate.png"
          alt=""
          style="width: 12%; height: 24px"
        />&nbsp;&nbsp;<span>{{ lang.Corporate_Customers }}</span>
      </a>
    </li> -->

    <!-- <li class="nav-item">
      <a
        class="nav-link"
        routerLink="/manageMembers"
        [routerLinkActive]="['active']"
        ><img
          src="../../../assets/img/managecorporate.png"
          alt=""
          style="width: 12%; height: 24px"
        />&nbsp;&nbsp;<span>{{ lang.Members }}</span>
      </a>
    </li> -->

    <!-- <li class="nav-item"> <a class="nav-link " routerLink="/manageClients"><img src="../../../assets/img/managecorporate.png" alt="" style="width:12%;height:24px">&nbsp;&nbsp;<span>Manage Corporate Clients</span> </a></li> -->
<!-- 
    <li class="nav-item" *ngIf="role == 'ADMINISTRATOR'">
      <a class="nav-link" routerLink="/invoices" [routerLinkActive]="['active']"
        ><img
          src="../../../assets/img/Inovicesicon.png"
          alt=""
          style="width: 12%; height: 24px"
        />&nbsp;&nbsp;<span>{{ lang.Invoices }}</span>
      </a>
    </li> -->

    <li class="nav-item" style="border-bottom: 1px solid white !important;">
  <a class="nav-link" routerLink="/manageCorporates" [routerLinkActive]="['active']">
    <img
      src="../../../assets/img/managecorporate.png"
      alt=""
      style="width: 24px; height: 24px; vertical-align: middle"
    />
    <span style="margin-left: 8px;">{{ lang.Corporate_Customers }}</span>
  </a>
</li>

<li class="nav-item" style="border-bottom: 1px solid white !important;">
  <a class="nav-link" routerLink="/manageMembers" [routerLinkActive]="['active']">
    <img
      src="../../../assets/img/managecorporate.png"
      alt=""
      style="width: 24px; height: 24px; vertical-align: middle"
    />
    <span style="margin-left: 8px;">{{ lang.Members }}</span>
  </a>
</li>

 <li class="nav-item" *ngIf="role != 'ADMINISTRATOR'" style="border-bottom: 1px solid white !important;">
      <a
        class="nav-link"
        routerLink="/invoices"
        [routerLinkActive]="['active']"
        ><img
          src=" ../../../assets/img/Inovicesicon.png"
          alt=""
          style="width: 12%; height: 24px"
        />&nbsp;&nbsp;<span>
          <!-- {{ lang.Invoices }}  -->
            Financials

        </span>
      </a>
    </li>


<li class="nav-item" *ngIf="role == 'ADMINISTRATOR'">
  <a
    class="nav-link"
    data-bs-target="#forms-nav-invoices"
    data-bs-toggle="collapse"
    href="#"
    (click)="toggleChevronInvoices()"
    routerLink="/invoices"
    [routerLinkActive]="['active']"
    [routerLinkActiveOptions]="{ exact: false }"
  >
    <img
     src="../../../assets/img/Inovicesicon.png"
      alt=""
      style="width: 12%; height: 24px"
    />
    &nbsp;&nbsp;<span>
      <!-- {{ lang.Invoices }} -->
        Financials  
          </span>
    <i
      [ngClass]="{
        'bi-chevron-right': !showChevronInvoices,
        'bi-chevron-down': showChevronInvoices
      }"
      class="ms-auto"
    ></i>
  </a>

  <ul
    *ngIf="role == 'ADMINISTRATOR'"
    id="forms-nav-invoices"
    class="nav-content collapse ulheigh"
  >
    <!-- Sub-link: Invoices -->
  

    <!-- Sub-link: Receivables -->
    <li class="nav-item">
      <a
        class="nav-link"
        routerLink="/invoices"
        [routerLinkActive]="['active']"
      >
        <img
         src="../../../assets/img/Inovicesicon.png"
          alt=""
          style="width: 12%; height: 24px"
        />
        &nbsp;&nbsp;<span>
          Invoices
        </span>
      </a>
    </li>
     <li class="nav-item">
      <a
        class="nav-link"
        routerLink="/receivables"
        [routerLinkActive]="['active']"
      >
        <img
         src="../../../assets/img/Inovicesicon.png"
          alt=""
          style="width: 12%; height: 24px"
        />
        &nbsp;&nbsp;<span>
          Receivables
        </span>
      </a>
    </li>
    <li class="nav-item">
      <a
        class="nav-link"
        routerLink="/payable"
        [routerLinkActive]="['active']"
      >
        <img
         src="../../../assets/img/Inovicesicon.png"
          alt=""
          style="width: 12%; height: 24px"
        />
        &nbsp;&nbsp;<span>
          Payables
        </span>
      </a>
    </li>
  </ul>
</li>





    <li class="nav-item" *ngIf="role == 'ADMINISTRATOR' || role === 'BROKER'">
      <a
        class="nav-link collapsed"
        data-bs-target="#forms-nav5"
        data-bs-toggle="collapse"
        href="#"
        (click)="toggleQueues()"
        routerLink="/provisioning"
        [routerLinkActive]="['active']"
        ><img
          src="../../../assets/img/reportsicon.png"
          alt=""
          style="width: 12%; height: 24px"
        />&nbsp;&nbsp;<span>{{ lang?.Queues || "Queues" }}</span>
        <i
          *ngIf="role == 'ADMINISTRATOR' || role === 'BROKER'"
          [ngClass]="{
            'bi-chevron-right': showQueues,
            'bi-chevron-down': !showQueues
          }"
          class="ms-auto"
        ></i>
      </a>
      <ul
        *ngIf="role == 'ADMINISTRATOR'"
        id="forms-nav5"
        class="nav-content collapse ulheigh"
      >
        <li class="nav-item" *ngIf="role == 'ADMINISTRATOR'">
          <a
            class="nav-link"
            routerLink="/provisioning"
            [routerLinkActive]="['active']"
            ><img
              src="../../../assets/img/reportsicon.png"
              alt=""
              style="width: 12%; height: 24px"
            />&nbsp;&nbsp;<span>{{ lang.Provisioning }}</span>
          </a>
        </li>

        <li class="nav-item" *ngIf="role == 'ADMINISTRATOR'">
          <a
            class="nav-link"
            (click)="isLinkActive ? null : $event.preventDefault()"
            routerLink="/underwriting-queue"
            [routerLinkActive]="['active']"
            ><img
              src="../../../assets/img/settingsicon.png"
              alt=""
              style="width: 12%; height: 24px"
            />&nbsp;&nbsp;<span>Underwriting</span>
          </a>
        </li>
      </ul>
    </li>

    <li class="nav-item" *ngIf="role == 'ADMINISTRATOR' || role === 'BROKER'">
      <a
        class="nav-link collapsed"
        data-bs-target="#forms-nav3"
        data-bs-toggle="collapse"
        href="#"
        (click)="toggleReports()"
        routerLink="/reports"
        [routerLinkActive]="['active']"
        ><img
          src="../../../assets/img/reportsicon.png"
          alt=""
          style="width: 12%; height: 24px"
        />&nbsp;&nbsp;<span>{{ lang.Reports }}</span>
        <i
          *ngIf="role == 'ADMINISTRATOR' || role === 'BROKER'"
          [ngClass]="{
            'bi-chevron-right': showReports,
            'bi-chevron-down': !showReports
          }"
          class="ms-auto"
        ></i>
      </a>
      <ul
        *ngIf="role == 'ADMINISTRATOR'"
        id="forms-nav3"
        class="nav-content collapse ulheigh"
      >
        <li class="nav-item" *ngIf="role == 'ADMINISTRATOR'">
          <a
            class="nav-link"
            routerLink="/travel-commissions"
            [routerLinkActive]="['active']"
            ><img
              src="../../../assets/img/reportsicon.png"
              alt=""
              style="width: 12%; height: 24px"
            />&nbsp;&nbsp;<span>{{ lang.Travel_Commissions }}</span>
          </a>
        </li>

        <li class="nav-item" *ngIf="role == 'ADMINISTRATOR'">
          <a
            class="nav-link"
            routerLink="/reports-schedule"
            [routerLinkActive]="['active']"
            ><img
              src="../../../assets/img/settingsicon.png"
              alt=""
              style="width: 12%; height: 24px"
            />&nbsp;&nbsp;<span>{{ lang.Reports_Schedule }}</span>
          </a>
        </li>
      </ul>
    </li>

    <li class="nav-item">
      <a
        class="nav-link"
        (click)="isLinkActive ? null : $event.preventDefault()"
        routerLink="/brochures"
        [routerLinkActive]="['active']"
        ><img
          src="../../../assets/img/marketing.png"
          alt=""
          style="width: 12%; height: 24px"
        />&nbsp;&nbsp;<span>{{ lang.Marketing_Brochures }}</span>
      </a>
    </li>

    <!-- <li class="nav-item" *ngIf="role=='ADMINISTRATOR'"> <a class="nav-link " [class.disabled]="!isLinkActive"
            (click)="isLinkActive ? null : $event.preventDefault()" routerLink="/marketing&promotions"
            [routerLinkActive]="['active']"><img src="../../../assets/img/marketing.png" alt=""
               style="width:12%;height:24px">&nbsp;&nbsp;<span>{{lang.Marketing_Promotions}}</span> </a></li> -->

    <li class="nav-item" *ngIf="role == 'ADMINISTRATOR'">
      <a
        class="nav-link"
        (click)="isLinkActive ? null : $event.preventDefault()"
        routerLink="/settings"
        [routerLinkActive]="['active']"
        ><img
          src="../../../assets/img/settingsicon.png"
          alt=""
          style="width: 12%; height: 24px"
        />&nbsp;&nbsp;<span>{{ lang.Settings }}</span>
      </a>
    </li>

    <!-- <li class="nav-item" *ngIf="role=='ADMINISTRATOR'"> <a class="nav-link " routerLink="/payments"
         [routerLinkActive]="['active']"><img src="../../../assets/img/Inovicesicon.png" alt=""
            style="width:12%;height:24px">&nbsp;&nbsp;<span>Payments</span> </a></li> -->

    <!-- <li class="nav-item" *ngIf="role=='ADMINISTRATOR'">

         <a class="nav-link collapsed " data-bs-target="#forms-nav4" data-bs-toggle="collapse" href="#"
            (click)="togglePayments()" [routerLinkActive]="['active']"><img
               src="../../../assets/img/payablesicon.png" alt=""
               style="width:12%;height:24px">&nbsp;&nbsp;<span>Electronic Payments</span>
            <i *ngIf="role=='ADMINISTRATOR' || role === 'BROKER'"
               [ngClass]="{'bi-chevron-right': showPayments, 'bi-chevron-down': !showPayments}"
               class="ms-auto"></i>
         </a>
         <ul *ngIf="role=='ADMINISTRATOR'" id="forms-nav4" class="nav-content collapse ulheigh">


            <li class="nav-item" *ngIf="role=='ADMINISTRATOR'"> <a class="nav-link "
                   routerLink="/payment-pds"
                  [routerLinkActive]="['active']"><img src="../../../assets/img/payablesicon.png" alt=""
                     style="width:12%;height:24px">&nbsp;&nbsp;<span>PDS</span> </a></li>
            <li class="nav-item" *ngIf="role=='ADMINISTRATOR'"> <a class="nav-link "
                routerLink="/reports-schedule"
               [routerLinkActive]="['active']"><img src="../../../assets/img/payablesicon.png" alt=""
                  style="width:12%;height:24px">&nbsp;&nbsp;<span>PAP</span> </a></li>
            <li class="nav-item" *ngIf="role=='ADMINISTRATOR'"> <a class="nav-link "
                routerLink="/reports-schedule"
               [routerLinkActive]="['active']"><img src="../../../assets/img/payablesicon.png" alt=""
                  style="width:12%;height:24px">&nbsp;&nbsp;<span>Credit card</span> </a></li>

         </ul>


      </li> -->
    <!-- <li class="nav-item" *ngIf="role === 'ADMINISTRATOR' || role === 'BROKER'"> <a class="nav-link"
           routerLink="/reports"
            [routerLinkActive]="['active']"><img src="../../../assets/img/reportsicon.png" alt=""
               style="width:12%;height:24px">&nbsp;&nbsp;<span>Reports</span> </a></li> -->
    <!-- <li class="nav-item" *ngIf="role === 'ADMINISTRATOR' || role === 'BROKER'"> <a class="nav-link"
           routerLink="/reports-schedule"
            [routerLinkActive]="['active']"><img src="../../../assets/img/settingsicon.png" alt=""
               style="width:12%;height:24px">&nbsp;&nbsp;<span>Reports Schedule</span> </a></li> -->
    <!-- <li class="nav-item" *ngIf="role === 'ADMINISTRATOR'"> <a class="nav-link"
           routerLink="/travel-commissions"
            [routerLinkActive]="['active']"><img src="../../../assets/img/reportsicon.png" alt=""
               style="width:12%;height:24px">&nbsp;&nbsp;<span>Travel Commissions</span> </a></li> -->

    <!--
         <li class="nav-item"> <a class="nav-link " routerLink="/dashboard"> <img src="assets/img/actions.png" alt="">&nbsp;&nbsp;<span>Add/Edit Corporate</span> </a></li> -->

    <!-- <li class="nav-item"> <a class="nav-link " routerLink="/dashboard"> <img src="assets/img/manageplans.png" alt="">&nbsp;&nbsp;<span>Manage Plans</span> </a></li> -->

    <!-- <li class="nav-item"> <a class="nav-link " routerLink="/dashboard"> <img src="assets/img/reports.png" alt="">&nbsp;&nbsp; <span>Reports</span> </a></li> -->

    <!-- <li class="nav-item">
        <a class="nav-link collapsed" data-bs-target="#forms-nav" data-bs-toggle="collapse" href="#"> <i class="bi bi-journal-text"></i><span>Forms</span><i class="bi bi-chevron-down ms-auto"></i> </a>
        <ul id="forms-nav" class="nav-content collapse " data-bs-parent="#sidebar-nav">
           <li class="nav-item"> <a class="nav-link " routerLink="/form-elements"> <span>Form Elements</span> </a></li>
           <li class="nav-item"> <a class="nav-link " routerLink="/form-layouts"> <span>Form Layouts</span> </a></li>
           <li class="nav-item"> <a class="nav-link " routerLink="/form-editors"> <span>Form Editors</span> </a></li>
        </ul>
     </li> -->
    <!-- <li class="nav-item">
          <a class="nav-link collapsed" data-bs-target="#components-nav" data-bs-toggle="collapse" href="#"> <i class="bi bi-menu-button-wide"></i><span>Components</span><i class="bi bi-chevron-down ms-auto"></i> </a>
          <ul id="components-nav" class="nav-content collapse " data-bs-parent="#sidebar-nav">
             <li> <a routerLink="/alerts"> <i class="bi bi-circle"></i><span>Alerts</span> </a></li>
             <li> <a routerLink="/accordion"> <i class="bi bi-circle"></i><span>Accordion</span> </a></li>
             <li> <a routerLink="/badges"> <i class="bi bi-circle"></i><span>Badges</span> </a></li>
             <li> <a routerLink="/breadcrumbs"> <i class="bi bi-circle"></i><span>Breadcrumbs</span> </a></li>
             <li> <a routerLink="/buttons"> <i class="bi bi-circle"></i><span>Buttons</span> </a></li>
             <li> <a routerLink="/cards"> <i class="bi bi-circle"></i><span>Cards</span> </a></li>
             <li> <a routerLink="/carousel"> <i class="bi bi-circle"></i><span>Carousel</span> </a></li>
             <li> <a routerLink="/list-group"> <i class="bi bi-circle"></i><span>List group</span> </a></li>
             <li> <a routerLink="/modal"> <i class="bi bi-circle"></i><span>Modal</span> </a></li>
             <li> <a routerLink="/tabs"> <i class="bi bi-circle"></i><span>Tabs</span> </a></li>
             <li> <a routerLink="/pagination"> <i class="bi bi-circle"></i><span>Pagination</span> </a></li>
             <li> <a routerLink="/progress"> <i class="bi bi-circle"></i><span>Progress</span> </a></li>
             <li> <a routerLink="/spinners"> <i class="bi bi-circle"></i><span>Spinners</span> </a></li>
             <li> <a routerLink="/tooltips"> <i class="bi bi-circle"></i><span>Tooltips</span> </a></li>
          </ul>
       </li>
       <li class="nav-item">
          <a class="nav-link collapsed" data-bs-target="#forms-nav" data-bs-toggle="collapse" href="#"> <i class="bi bi-journal-text"></i><span>Forms</span><i class="bi bi-chevron-down ms-auto"></i> </a>
          <ul id="forms-nav" class="nav-content collapse " data-bs-parent="#sidebar-nav">
             <li> <a routerLink="/form-elements"> <i class="bi bi-circle"></i><span>Form Elements</span> </a></li>
             <li> <a routerLink="/form-layouts"> <i class="bi bi-circle"></i><span>Form Layouts</span> </a></li>
             <li> <a routerLink="/form-editors"> <i class="bi bi-circle"></i><span>Form Editors</span> </a></li>
          </ul>
       </li>
       <li class="nav-item">
          <a class="nav-link collapsed" data-bs-target="#tables-nav" data-bs-toggle="collapse" href="#"> <i class="bi bi-layout-text-window-reverse"></i><span>Tables</span><i class="bi bi-chevron-down ms-auto"></i> </a>
          <ul id="tables-nav" class="nav-content collapse " data-bs-parent="#sidebar-nav">
             <li> <a routerLink="/tables-general"> <i class="bi bi-circle"></i><span>General Tables</span> </a></li>
             <li> <a routerLink="/tables-data"> <i class="bi bi-circle"></i><span>Data Tables</span> </a></li>
          </ul>
       </li>
       <li class="nav-item">
          <a class="nav-link collapsed" data-bs-target="#charts-nav" data-bs-toggle="collapse" href="#"> <i class="bi bi-bar-chart"></i><span>Charts</span><i class="bi bi-chevron-down ms-auto"></i> </a>
          <ul id="charts-nav" class="nav-content collapse " data-bs-parent="#sidebar-nav">
             <li> <a routerLink="/charts-chartjs"> <i class="bi bi-circle"></i><span>Chart.js</span> </a></li>
             <li> <a routerLink="/charts-apexcharts"> <i class="bi bi-circle"></i><span>ApexCharts</span> </a></li>
          </ul>
       </li>
       <li class="nav-item">
          <a class="nav-link collapsed" data-bs-target="#icons-nav" data-bs-toggle="collapse" href="#"> <i class="bi bi-gem"></i><span>Icons</span><i class="bi bi-chevron-down ms-auto"></i> </a>
          <ul id="icons-nav" class="nav-content collapse " data-bs-parent="#sidebar-nav">
             <li> <a routerLink="/icons-bootstrap"> <i class="bi bi-circle"></i><span>Bootstrap Icons</span> </a></li>
             <li> <a routerLink="/icons-remix"> <i class="bi bi-circle"></i><span>Remix Icons</span> </a></li>
             <li> <a routerLink="/icons-boxicons"> <i class="bi bi-circle"></i><span>Boxicons</span> </a></li>
          </ul>
       </li>
       <li class="nav-heading">Pages</li>
       <li class="nav-item"> <a class="nav-link collapsed" routerLink="/user-profile"> <i class="bi bi-person"></i> <span>Profile</span> </a></li>
       <li class="nav-item"> <a class="nav-link collapsed" routerLink="/pages-faq"> <i class="bi bi-question-circle"></i> <span>F.A.Q</span> </a></li>
       <li class="nav-item"> <a class="nav-link collapsed" routerLink="/pages-contact"> <i class="bi bi-envelope"></i> <span>Contact</span> </a></li>
       <li class="nav-item"> <a class="nav-link collapsed" routerLink="/pages-register"> <i class="bi bi-card-list"></i> <span>Register</span> </a></li>
       <li class="nav-item"> <a class="nav-link collapsed" routerLink="/pages-login"> <i class="bi bi-box-arrow-in-right"></i> <span>Login</span> </a></li>
       <li class="nav-item"> <a class="nav-link collapsed" routerLink="/pages-error404"> <i class="bi bi-dash-circle"></i> <span>Error 404</span> </a></li>
       <li class="nav-item"> <a class="nav-link collapsed" routerLink="/pages-blank"> <i class="bi bi-file-earmark"></i> <span>Blank</span> </a></li> -->
  </ul>
</aside>
